const getPermissionValue = (value) => {
  if (typeof value === 'boolean') return value;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['true', '1', 'yes', 'y'].includes(normalized)) return true;
    if (['false', '0', 'no', 'n', 'null', 'undefined', ''].includes(normalized)) return false;
  }

  return Boolean(value);
};

export const saveUserPermissions = (response) => {
  const getPermissionFromResponse = (fieldNames) => {
    const candidates = [response, response?.data, response?.result, response?.response].filter(Boolean);

    for (const candidate of candidates) {
      for (const fieldName of fieldNames) {
        if (candidate[fieldName] !== undefined) {
          return getPermissionValue(candidate[fieldName]);
        }
      }
    }

    return false;
  };

  const smsPermission = getPermissionFromResponse([
    'isPermissionsSMS',
    'ispermissionsSMS',
    'IsPermissionsSMS',
  ]);

  const emailPermission = getPermissionFromResponse([
    'isPermissionsEmail',
    'ispermissionsEmail',
    'IsPermissionsEmail',
  ]);

  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem('ispermissionsSMS', String(smsPermission));
    window.localStorage.setItem('ispermissionsEmail', String(emailPermission));
  }

  return {
    sms: smsPermission,
    email: emailPermission,
  };
};

export const getStoredPermission = (key) => {
  if (typeof window === 'undefined' || !window.localStorage) return false;

  const value = window.localStorage.getItem(key);
  if (value === null) return false;

  return getPermissionValue(value);
};

export const getUserPermissions = () => ({
  sms: getStoredPermission('ispermissionsSMS'),
  email: getStoredPermission('ispermissionsEmail'),
});

export const canAccessPage = (page, permissions = getUserPermissions()) => {
  const hasSms = permissions.sms;
  const hasEmail = permissions.email;

  switch (page) {
    case 'number':
    case 'template':
    case 'traffic':
    case 'failure':
      return hasSms;

    case 'email-monitoring':
      return hasEmail;

    case 'subject-wise-report':
      return hasEmail;

    default:
      return true;
  }
};
